export enum ActionTypes {
 ADD_INTEGRATION = '[ADD_INTEGRATION] Add integration',
 ADD_INTEGRATION_SUCCESS = '[ADD_INTEGRATION] Add integration success',
 ADD_INTEGRATION_FAILURE = '[ADD_INTEGRATION] Add integration failure',
}
